<template>
  <div>
    <e-tabs v-if="false" :list="this.$constant.tabListGoodsSystem()" isJump />
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped></style>
